import { render, staticRenderFns } from "./brandManagerment.vue?vue&type=template&id=9328976e&scoped=true&"
import script from "./brandManagerment.vue?vue&type=script&lang=js&"
export * from "./brandManagerment.vue?vue&type=script&lang=js&"
import style0 from "./brandManagerment.vue?vue&type=style&index=0&id=9328976e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9328976e",
  null
  
)

export default component.exports